<template>
    <div class="pdf-viewer-native">
        <object :data="src" type="application/pdf" width="100%" height="100%">
            <!-- Fallback content can be added here if PDF cannot be displayed -->
        </object>
    </div>
</template>

<script>
export default {
    name: 'PDFViewerNative',
    props: {
        src: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.pdf-viewer-native {
    height: 100%;
    width: 100%;
    overflow: hidden;

    object {
        width: 100%;
        height: 100%;
        border: none;
        display: block;
    }
}
</style>
